import { render } from "./TransferPaymentDateFieldContainer.vue?vue&type=template&id=5bd4c7b3"
import script from "./TransferPaymentDateFieldContainer.vue?vue&type=script&lang=js"
export * from "./TransferPaymentDateFieldContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__